import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import classNames from 'classnames';
import { formatDomainActions, formatDns, formatName } from '../../domainManagerGridFormatter';
import styles from '../style.scss';
import ScreenLoaderContainer from '../../../portal/controls/screenLoaderContainer';

export default class DomainsList extends Component {

    render() {

        const { domains } = this.props;
        if (!domains) {

            return <ScreenLoaderContainer />;
        }        

        return domains.length > 0 ? <BootstrapTable
            data={domains}
            striped
            hover
            tableContainerClass={classNames(styles.innerTableContainerWrapper)}
            bodyContainerClass={classNames(styles.tableBodyWrapper)}
            headerContainerClass={classNames(styles.innerTabGridHeader)}
            trClassName={classNames(styles.tableRow)}
            containerClass={classNames(styles.tableStyle)}
        >
            <TableHeaderColumn dataField='id' className={classNames(styles.tableHeader)}
                dataFormat={formatName}>
                {this.props.translations.DOMAIN_NAME}
            </TableHeaderColumn>

            <TableHeaderColumn dataField='id' className={classNames(styles.tableHeader)}
                dataFormat={formatDns}>
                {this.props.translations.DNS_DOMAIN}
            </TableHeaderColumn>

            <TableHeaderColumn dataField='id' isKey={true} className={classNames(styles.tableHeader)} width='150px'
                dataFormat={formatDomainActions}>
            </TableHeaderColumn>
        </BootstrapTable> : null;
    }
}


// WEBPACK FOOTER //
// ./src/components/generalSettings/domainManager/domainsList/index.jsx